import request from './base';

const api = {
    baseinfo() {
        return request.get('/api/Dake/getBaseInfo');
    }
};

export default api;
